import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { StaffCard } from 'src/app/admin/models/staffCard';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { StaffcardService } from 'src/app/admin/services/staffcard.service';
import { validateStaffCard } from 'src/app/utils/formValidators';

@Component({
  selector: 'app-edit-staffcard-modal',
  templateUrl: './edit-staffcard-modal.component.html',
  styleUrls: ['./edit-staffcard-modal.component.scss'],
})
export class EditStaffcardModalComponent implements OnInit {
  staffCard: StaffCard = new StaffCard();
  errMsg = '';
  checkboxes : any[];
  playrooms$ = this.roomService.playrooms$; 
   staffCard$=this.staffCardService.staffCard$;
   constructor(private modalController: ModalController,private roomService: PlayroomService, private staffCardService: StaffcardService ) { 
   
}
 
   ngOnInit() {
    this.playrooms$.subscribe((rooms) => {
      console.log("playrooms$");
      console.log(rooms);
      this.checkboxes = rooms;
      this.checkboxes.map((x) => x.checked = this.staffCard.roomIds.includes(x.id));
    });
    this.roomService.getAllPlayrooms();
   }
   editStaffCard() {
    this.staffCard.roomIds = this.checkboxes.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.id);


     const formValidation = validateStaffCard(this.staffCard);
     this.errMsg = formValidation.errMsg;
     if(formValidation.isValid) {
       this.staffCardService.editStaffCard(this.staffCard).subscribe(res => {
         this.staffCardService.getAllStaffCard({currentPage: 1, itemsPerPage: 100,
           enterQuery: '',  fullNameQuery: '',roomNameQuery:''});
         this.dismissModal();
       },(err) => {
         console.error(err);
       });
     }
   }
  dismissModal() {
     this.modalController.dismiss();
   }
 }
 